import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import getFormattedValues, { formatReceived } from 'utils/formatValues';

export const baseURI = 'nominas/seguro-imss-registro-cuenta-contable-pasivo-empleado/';
/**
 * GET Base De Calculos
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getCuentasContablesPasivoEmpleado = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Base De Calculo
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getCuentaContablePasivoEmpleado = async (id) => {
  try {
    const response = await API.get(`${baseURI} ${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Base De Calculo
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postCuentaContablePasivoEmpleado = async (values) => {
  try {
    const response = await API.post(baseURI, getFormattedValues(values));
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Base De Calculo
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchCuentaContablePasivoEmpleado = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE UMA General
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteCuentaContablePasivoEmpleado = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
